module.exports = __webpack_public_path__ + "fonts/HelveticaNowDisplay-XBold.5626e1fefa4eb15fb5d2ac8febff5ef4.woff2";